/* eslint-disable react/no-array-index-key */
import {Fragment} from "react";
import {Link} from "react-router-dom";
import {isBlankHTML} from "lib/ext/string";
import useAppContext from "lib/hooks/use-app-context";

export default function Links() {
  const {unknown, user} = useAppContext();

  if(!unknown) { return null; }

  const answers = unknown.questions.map(({answer}) => !isBlankHTML(answer));
  const questions = unknown.questions.map(({content}) => !isBlankHTML(content));
  const display = ({name, index, total}) => (total === 1 ? name : `${name} ${index}`);
  let totalAnswers = 0;
  answers.forEach((value, index) => {
    if(!value) { return; }

    totalAnswers += 1;
    answers[index] = totalAnswers;
  });

  let totalQuestions = 0;
  questions.forEach((value, index) => {
    if(!value) { return; }

    totalQuestions += 1;
    questions[index] = totalQuestions;
  });

  return (
    <>
      <div className="btn-group block text-center">
        {!isBlankHTML(unknown.content) && (
          <Link className="btn btn-sm btn-yellow" to={`/unknowns/${unknown.id}/content`}>Content</Link>
        )}
        {unknown.questions.map((_, index) => (
          <Fragment key={index}>
            {questions[index] && (
              <Link className="btn btn-sm btn-dark-gray" to={`/unknowns/${unknown.id}/question/${questions[index]}`}>
                {display({name: "Question", index: questions[index], total: totalQuestions})}
              </Link>
            )}
            {answers[index] && (
              <Link className="btn btn-sm btn-blue" to={`/unknowns/${unknown.id}/answer/${answers[index]}`}>
                {display({name: "Answer", index: answers[index], total: totalAnswers})}
              </Link>
            )}
          </Fragment>
        ))}
        <Link className="btn btn-sm btn-green" to={`/unknowns/${unknown.id}/deep-dive`}>Deep Dive</Link>
        <Link className="btn btn-sm btn-yellow" to={`/unknowns/${unknown.id}/quick-take`}>Quick Take</Link>
        <Link className="btn btn-sm btn-dark-gray" to={`/unknowns/${unknown.id}/comments`}>Comments</Link>
      </div>
      {user?.admin && (
        <div className="btn-group block mt-3 text-center">
          <Link className="btn btn-sm btn-dark-gray" to={`/admin/cases/${unknown.id}`}>Edit</Link>
        </div>
      )}
    </>
  );
}
